import { AdvisorsLayout, DirectorySection } from '@src/components/sco/Advisors'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  return (
    <AdvisorsLayout>
      <DirectorySection />
    </AdvisorsLayout>
  )
}
